<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="修改头像">
        <management></management>
      </el-tab-pane>
      <el-tab-pane label="密码设置">
        <password></password>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import management from "./management";
import password from "./password";
export default {
  components: {
    management,
    password
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// index.vue?0280ed16